import { render, staticRenderFns } from "./about-1.vue?vue&type=template&id=66a3cbd2&"
import script from "./about-1.vue?vue&type=script&lang=js&"
export * from "./about-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports